import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  question: '¿Es material digital?',
  answer: 'Sí, acceso y descarga inmediata. Podrás acceder al contenido desde tu celular, tablet o computadora en cualquier momento.'
}, {
  question: '¿Para qué edades sirve?',
  answer: 'El programa está diseñado específicamente para padres de niños de 2 a 12 años, abarcando las etapas críticas de desarrollo y formación de hábitos.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No. Está pensado para padres reales, con lenguaje sencillo y pasos claros. No necesitas ser experto en tecnología ni en pedagogía.'
}, {
  question: '¿Funciona si ya hay problemas?',
  answer: 'Sí, incluso si sentís que la situación está avanzada. Las estrategias incluyen técnicas para "desintoxicar" y restablecer límites aunque ya exista una dependencia fuerte.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-135">
      {FAQS.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden shadow-sm bg-white" data-id="element-136">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-137">
            <span className="font-bold text-gray-900 text-lg" data-id="element-138">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-blue-600" data-id="element-139" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-140" />}
          </button>

          {openIndex === index && <div className="p-5 pt-0 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-141">
              <div className="mt-4" data-id="element-142">{faq.answer}</div>
            </div>}
        </div>)}
    </div>;
}